"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check if the parameter is numeric or can be treated as numeric (ie. 3 or '3').
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#isnumericpossible_number}
 */
function isNumeric(possible_number) {
    return !isNaN(parseFloat(possible_number)) && isFinite(possible_number);
}
exports.default = isNumeric;
